<template>
  <modal @close="clearForm" :show.sync="$parent.modals.changePassword">
    <h6 slot="header" class="modal-title" id="modal-title-default">
      Change Password
      <small class="mt-2 d-block">Password must be at least 8 characters long.</small>
    </h6>

    <form role="form" @submit.prevent="handleSubmit">
      <div class="form-group">
        <base-input
          label="Current Password"
          type="password"
          placeholder="Enter current password"
          v-model="form.oldpassword"
          required
          spellcheck="false"
        ></base-input>
      </div>
      <div class="form-group">
        <base-input
          label="New Password"
          type="password"
          placeholder="Enter new password"
          v-model="form.newpassword"
          required
          spellcheck="false"
        ></base-input>
      </div>
      <div class="form-group">
        <base-input
          label="Re-enter New Password"
          type="password"
          placeholder="Enter new password"
          v-model="form.repassword"
          required
          spellcheck="false"
        ></base-input>
      </div>
      <div class="password-errors">
        <div id="card-errors" role="alert">{{errorMessage}}</div>
      </div>
      <base-button :loading="loading" type="primary" nativeType="input" block>CHANGE PASSWORD</base-button>
    </form>
  </modal>
</template>

<script>
import swal from "sweetalert2";
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "change-password",
  data() {
    return {
      form: {
        oldpassword: "",
        newpassword: "",
        repassword: ""
      },
      loading: false,
      errorMessage: ""
    };
  },
  methods: {
    handleSubmit() {
      if (this.form.repassword == this.form.newpassword) {
        if (this.form.newpassword.length >= 8) {
          this.loading = true;
          this.axios
            .post(`${apiBaseURL}/api/artv1.1/user/changepassword`, {
              newpassword: this.form.newpassword,
              oldpassword: this.form.oldpassword
            })
            .then(result => {
              if (
                result.data.error_code == 0 &&
                result.data.message == "Success"
              ) {
                if (typeof result.data.data.status === "undefined") {
                  this.showErrorAlert(
                    "Unable to change password. Please try again."
                  );
                } else {
                  if (result.data.data.status == "succcess") {
                    this.showSuccessAlert();
                  } else {
                    this.showErrorAlert(
                      "Unable to change password. Please try again."
                    );
                  }
                }
              } else {
                this.showErrorAlert(
                  "Unable to change password. Please try again."
                );
              }
              this.loading = false;
            })
            .catch(error => {
              this.loading = false;
              this.showErrorAlert(
                "Unable to change password. Please try again."
              );
            });
        } else {
          this.errorMessage = "Password must be at least 8 characters long.";
        }
      } else {
        this.errorMessage = "Passwords do not match.";
      }
    },
    showSuccessAlert() {
      swal.fire({
        type: "success",
        title: "Success!",
        text: "Your password has been updated.",
        confirmButtonColor: "#000",
        onClose: this.closeModal
      });
    },
    showErrorAlert(message) {
      swal.fire({
        type: "error",
        title: "Oh no!",
        text: message,
        confirmButtonColor: "#000"
      });
    },
    closeModal() {
      this.clearForm();
      this.$parent.modals.changePassword = false;
    },
    clearForm() {
      this.form.oldpassword = "";
      this.form.newpassword = "";
      this.form.repassword = "";
      this.errorMessage = "";
      this.loading = false;
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val.newpassword && val.repassword) {
          if (val.newpassword !== val.repassword) {
            this.errorMessage = "Passwords do not match.";
          } else {
            this.errorMessage = "";
          }
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
.password-errors {
  margin-bottom: 1.4rem;
  font-size: 0.875rem;
  color: red;
  text-align: center;
}
</style>
